import localStorageConst from '@constants/localStorage';
import localStorage from '../localStorage';

export const setLanguageToStorage = language => {
  localStorage.setItem(localStorageConst.LANGUAGE, language);
};

export const getLanguageFromStorage = () =>
  localStorage.getItem(localStorageConst.LANGUAGE);
